module.exports = "/img/rtwwbf.5cb36b23.png";